<template>
	<div class="hiq-search-sort">
    <label for="sortSelection" class="hiq-search-sort-label">Sortera listan efter </label>
    <select id="sortSelection" v-model="selectedSort" @change="selectedChanged()">
      <option v-for="option in sort" :value="option.name" :key="option.name"> {{ option.title }} </option>
    </select>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';
import { search } from '../store/actions';
import { ISort } from '../store/state';

interface ArticleSortData {
  selectedSort: string,
}

interface ArticleSortComputed {
  sort: ISort[],
}

interface ArticleSortMethods {
  selectedChanged(): void,
}

export default Vue.extend<ArticleSortData, ArticleSortMethods, ArticleSortComputed, {}>({
	name: 'ArticleSort',
  data() {
    return {
      selectedSort: new URL(location.href).searchParams.get("sortBy") || 'date'
    }
  },
  computed: {
    sort() {
      return this.$store.getters.sort;
    },
  },
  methods: {
    selectedChanged(){
      this.$store.commit({
        type: 'setSort',
        payload: this.selectedSort
      });
      this.$store.dispatch(search(''));
    }
  },
})
</script>
